import appLogo from "@/icon.png";
import { buildInvitationPresentation } from "../connection-presentation";

/**
 * 展示连接成功后的邀请摘要卡片。
 * @param {object} props 组件参数
 * @param {{ deviceId?: string }} [props.summary] 已连接设备概要
 * @param {() => void} props.onStartRemote 开始远程控制的回调
 * @param {() => void} props.onCancel 取消连接的回调
 */

type ConnectionSummary = {
	deviceId?: string;
	deviceInfo?: Record<string, unknown> | null;
	sessionInfo?: Record<string, unknown> | null;
	expiresAt?: string;
};

type InvitationCardProps = {
	summary?: ConnectionSummary | null;
	onStartRemote: () => void;
	onCancel: () => void;
};

const InvitationCard = ({
	summary,
	onStartRemote,
	onCancel,
}: InvitationCardProps) => {
	const {
		formattedExpirationText,
		deviceLocation,
		inviteeName,
		operatingSystem,
		ipAddress,
	} = buildInvitationPresentation(summary);

	return (
		<div className="rounded-3xl bg-white/90 p-10 shadow-2xl backdrop-blur">
			<div className="flex flex-col items-center text-center">
				<img src={appLogo} alt="EasyRemote logo" className="h-12" />
				<h2 className="mt-6 text-2xl font-semibold text-slate-900">
					Remote Invitation
				</h2>
				<p className="mt-2 text-sm text-slate-500">
					<b>{inviteeName}</b> invites you to start a remote control session.
				</p>
			</div>

			<div className="mt-8 space-y-3 rounded-2xl bg-white p-6 shadow-inner">
				<div className="flex items-center justify-between text-sm text-slate-600">
					<span className="font-medium text-slate-500">Device Code</span>
					<span className="font-semibold text-slate-800">
						{summary?.deviceId || "--"}
					</span>
				</div>
				<div className="flex items-center justify-between text-sm text-slate-600">
					<span className="font-medium text-slate-500">IP Address</span>
					<span className="font-semibold text-slate-800">{ipAddress}</span>
				</div>
				<div className="flex items-center justify-between text-sm text-slate-600">
					<span className="font-medium text-slate-500">Location</span>
					<span className="font-semibold text-slate-800">{deviceLocation}</span>
				</div>
				<div className="flex items-center justify-between text-sm text-slate-600">
					<span className="font-medium text-slate-500">Operating System</span>
					<span className="font-semibold text-slate-800">
						{operatingSystem}
					</span>
				</div>
			</div>

			<div className="mt-6 rounded-2xl border border-blue-100 bg-blue-50/80 p-4 text-sm text-blue-700">
				Please ensure the EasyRemote desktop client is running on the device so
				the session can start smoothly.
			</div>

			<div className="mt-8 flex flex-col gap-3">
				<button
					type="button"
					className="btn btn-primary btn-lg w-full"
					onClick={onStartRemote}
				>
					Start Session
				</button>
				<button
					type="button"
					className="btn btn-ghost btn-lg w-full"
					onClick={onCancel}
				>
					Cancel
				</button>
			</div>

			<p className="mt-6 text-center text-xs text-slate-400">
				{formattedExpirationText}
			</p>
		</div>
	);
};

export default InvitationCard;
